const REJECT_UNSUPPORTED_ATS_TOOLS = new Set(["gem", "applicantstack"]);

export const isRejectSupported = (atsIntegrationId) => {
  if (!atsIntegrationId) return false;
  const tool = atsIntegrationId.split(":")[0];
  return !REJECT_UNSUPPORTED_ATS_TOOLS.has(tool);
};

// Stored as ai_insights.resume_match_summary when there is no résumé score.
// Must match RESUME_UNAVAILABLE_MESSAGE / RESUME_NOT_COVERED_MESSAGE in
// backend/src/models/analysis.py; tests on both sides pin the exact text.
export const RESUME_MATCH_NO_RESUME_SUMMARY = "No resume available.";
export const RESUME_MATCH_NOT_COVERED_SUMMARY = "The interview didn't cover any resume claims.";
